import React, { useState } from 'react'
import { Container } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './layout.module.css'
import Navbar from '../nav-bar/nav-bar'
import CustomSidebar from '../sidebar/sidebar'
import ContentLoader from '../content-loader/content-loader'

const Layout = ({ children }) => {
  const [containerMarginTop, setContainerMarginTop] = useState()
  return (
    <>
      <Navbar setContainerMarginTop={setContainerMarginTop} />
      <CustomSidebar />
      <Container
        style={{ marginTop: containerMarginTop + 12 }}
        className={cx(styles.container)}
      >
        {children}
      </Container>

      <ContentLoader />
    </>
  )
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
export default Layout
